import {
  Action,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import Registration, { EmptyRegistration } from '@/models/registration';
import RetailerService from '@/services/retailer.service';
import store from '..';

export enum RegistrationStatus {
  Initial,
  InProgress,
  Succeeded,
  Failed,
}

@Module({
  store,
  name: 'registration',
  namespaced: true,
  dynamic: true,
})
export default class RegistrationModule extends VuexModule {
  registration: Registration = EmptyRegistration;
  status = RegistrationStatus.Initial;
  message = '';

  @Mutation
  setRegistration(registration: Registration) {
    this.status = RegistrationStatus.InProgress;
    this.message = '';
    this.registration = registration;
  }

  @Mutation
  setStatus(newStatus: RegistrationStatus) {
    this.status = newStatus;
    if (this.status !== RegistrationStatus.Failed) {
      this.message = '';
    }
  }

  @Mutation
  setError(message: string) {
    this.status = RegistrationStatus.Failed;
    this.message = message;
  }

  @Action
  startRegistration() {
    this.context.commit('setRegistration', EmptyRegistration);
    this.context.commit('setStatus', RegistrationStatus.Initial);
  }

  @Action
  async requestRegistration() {
    this.context.commit('setStatus', RegistrationStatus.InProgress);
    return RetailerService.requestRegistration(this.registration)
      .then(() => {
        this.context.commit('setStatus', RegistrationStatus.Succeeded);
      })
      .catch((error) => {
        if (error.response.data.message) {
          this.context.commit('setError', error.response.data.message);
        } else {
          this.context.commit('setError', 'There was an error in your request, please try again or contact the support team.');
        }
      });
  }
}
